import { signaux, type CandidatureResume } from '@rh/shared';
import { dateHeure } from '../format';

/** Badges et alertes d'une candidature (docs/UI.md § Badges et alertes). */
export function Signaux({ candidature }: { candidature: CandidatureResume }) {
  const liste = signaux(candidature);
  if (liste.length === 0) return null;
  return (
    <span className="signaux">
      {liste.map((signal) => (
        <span key={signal.cle} className={`signal-${signal.niveau}`}>
          {signal.libelle}
          {signal.date && ` · ${dateHeure(signal.date)}`}
        </span>
      ))}
    </span>
  );
}
